/**
 * Binga Cart - Sistema de carrito para Binga.cl
 * Maneja: Selector de comunas, cálculo de tarifas, documento tributario
 * Version: 2.0
 */

const BingaCart = {
  // Configuración
  config: {
    debug: true,
    currency: 'CLP'
  },

  // Estado
  state: {
    region: '',
    comuna: '',
    selectedRate: null,
    documentType: 'boleta',
    isReady: false
  },

  // Regiones y comunas de Chile
  regions: {
    "AP": { name: "Arica y Parinacota", comunas: ["Arica", "Camarones", "General Lagos", "Putre"] },
    "TA": { name: "Tarapacá", comunas: ["Alto Hospicio", "Camiña", "Colchane", "Huara", "Iquique", "Pica", "Pozo Almonte"] },
    "AN": { name: "Antofagasta", comunas: ["Antofagasta", "Calama", "María Elena", "Mejillones", "Ollagüe", "San Pedro de Atacama", "Sierra Gorda", "Taltal", "Tocopilla"] },
    "AT": { name: "Atacama", comunas: ["Alto del Carmen", "Caldera", "Chañaral", "Copiapó", "Diego de Almagro", "Freirina", "Huasco", "Tierra Amarilla", "Vallenar"] },
    "CO": { name: "Coquimbo", comunas: ["Andacollo", "Canela", "Combarbalá", "Coquimbo", "Illapel", "La Higuera", "La Serena", "Los Vilos", "Monte Patria", "Ovalle", "Paihuano", "Punitaqui", "Río Hurtado", "Salamanca", "Vicuña"] },
    "VS": { name: "Valparaíso", comunas: ["Algarrobo", "Cabildo", "Calera", "Calle Larga", "Cartagena", "Casablanca", "Catemu", "Concón", "El Quisco", "El Tabo", "Hijuelas", "Isla de Pascua", "Juan Fernández", "La Cruz", "La Ligua", "Limache", "Llaillay", "Los Andes", "Nogales", "Olmué", "Panquehue", "Papudo", "Petorca", "Puchuncaví", "Putaendo", "Quillota", "Quilpué", "Quintero", "Rinconada", "San Antonio", "San Esteban", "San Felipe", "Santa María", "Santo Domingo", "Valparaíso", "Villa Alemana", "Viña del Mar", "Zapallar"] },
    "RM": { name: "Región Metropolitana", comunas: ["Alhué", "Buin", "Calera de Tango", "Cerrillos", "Cerro Navia", "Colina", "Conchalí", "Curacaví", "El Bosque", "El Monte", "Estación Central", "Huechuraba", "Independencia", "Isla de Maipo", "La Cisterna", "La Florida", "La Granja", "La Pintana", "La Reina", "Lampa", "Las Condes", "Lo Barnechea", "Lo Espejo", "Lo Prado", "Macul", "Maipú", "María Pinto", "Melipilla", "Ñuñoa", "Padre Hurtado", "Paine", "Pedro Aguirre Cerda", "Peñaflor", "Peñalolén", "Pirque", "Providencia", "Pudahuel", "Puente Alto", "Quilicura", "Quinta Normal", "Recoleta", "Renca", "San Bernardo", "San Joaquín", "San José de Maipo", "San Miguel", "San Pedro", "San Ramón", "Santiago", "Talagante", "Tiltil", "Vitacura"] },
    "LI": { name: "O'Higgins", comunas: ["Chimbarongo", "Chépica", "Codegua", "Coinco", "Coltauco", "Doñihue", "Graneros", "La Estrella", "Las Cabras", "Litueche", "Lolol", "Machalí", "Malloa", "Marchigüe", "Mostazal", "Nancagua", "Navidad", "Olivar", "Palmilla", "Paredones", "Peralillo", "Peumo", "Pichidegua", "Pichilemu", "Placilla", "Pumanque", "Quinta de Tilcoco", "Rancagua", "Rengo", "Requínoa", "San Fernando", "San Vicente", "Santa Cruz"] },
    "ML": { name: "Maule", comunas: ["Cauquenes", "Chanco", "Colbún", "Constitución", "Curepto", "Curicó", "Empedrado", "Hualañé", "Licantén", "Linares", "Longaví", "Maule", "Molina", "Parral", "Pelarco", "Pelluhue", "Pencahue", "Rauco", "Retiro", "Río Claro", "Romeral", "Sagrada Familia", "San Clemente", "San Javier", "San Rafael", "Talca", "Teno", "Vichuquén", "Villa Alegre", "Yerbas Buenas"] },
    "NB": { name: "Ñuble", comunas: ["Bulnes", "Chillán", "Chillán Viejo", "Cobquecura", "Coelemu", "Coihueco", "El Carmen", "Ninhue", "Ñiquén", "Pemuco", "Pinto", "Portezuelo", "Quillón", "Quirihue", "Ránquil", "San Carlos", "San Fabián", "San Ignacio", "San Nicolás", "Treguaco", "Yungay"] },
    "BI": { name: "Biobío", comunas: ["Alto Biobío", "Antuco", "Arauco", "Cabrero", "Cañete", "Chiguayante", "Concepción", "Contulmo", "Coronel", "Curanilahue", "Florida", "Hualpén", "Hualqui", "Laja", "Lebu", "Los Álamos", "Los Ángeles", "Lota", "Mulchén", "Nacimiento", "Negrete", "Penco", "Quilaco", "Quilleco", "San Pedro de la Paz", "San Rosendo", "Santa Bárbara", "Santa Juana", "Talcahuano", "Tirúa", "Tomé", "Tucapel", "Yumbel"] },
    "AR": { name: "Araucanía", comunas: ["Angol", "Carahue", "Cholchol", "Collipulli", "Cunco", "Curacautín", "Curarrehue", "Ercilla", "Freire", "Galvarino", "Gorbea", "Lautaro", "Loncoche", "Lonquimay", "Los Sauces", "Lumaco", "Melipeuco", "Nueva Imperial", "Padre Las Casas", "Perquenco", "Pitrufquén", "Pucón", "Purén", "Renaico", "Saavedra", "Temuco", "Teodoro Schmidt", "Toltén", "Traiguén", "Victoria", "Vilcún", "Villarrica"] },
    "LR": { name: "Los Ríos", comunas: ["Corral", "Futrono", "La Unión", "Lago Ranco", "Lanco", "Los Lagos", "Máfil", "Mariquina", "Paillaco", "Panguipulli", "Río Bueno", "Valdivia"] },
    "LL": { name: "Los Lagos", comunas: ["Ancud", "Calbuco", "Castro", "Chaitén", "Chonchi", "Cochamó", "Curaco de Vélez", "Dalcahue", "Fresia", "Frutillar", "Futaleufú", "Hualaihué", "Llanquihue", "Los Muermos", "Maullín", "Osorno", "Palena", "Puerto Montt", "Puerto Octay", "Puerto Varas", "Puqueldón", "Purranque", "Puyehue", "Queilén", "Quellón", "Quemchi", "Quinchao", "Río Negro", "San Juan de la Costa", "San Pablo"] },
    "AI": { name: "Aysén", comunas: ["Aysén", "Chile Chico", "Cisnes", "Cochrane", "Coyhaique", "Guaitecas", "Lago Verde", "O'Higgins", "Río Ibáñez", "Tortel"] },
    "MA": { name: "Magallanes", comunas: ["Antártica", "Cabo de Hornos", "Laguna Blanca", "Natales", "Porvenir", "Primavera", "Punta Arenas", "Río Verde", "San Gregorio", "Timaukel", "Torres del Paine"] }
  },

  // Inicializar
  init() {
    this.log('Inicializando BingaCart...');
    this.renderShippingCalculator();
    this.renderDocumentSelector();
    this.bindEvents();
    this.updateCheckoutButton();
    this.log('BingaCart inicializado');
  },

  // Renderizar calculador de envío
  renderShippingCalculator() {
    const container = document.getElementById('binga-shipping');
    if (!container) return;

    container.innerHTML = `
      <div class="binga-shipping-header">
        <span class="binga-icon">📍</span>
        <span class="binga-title">¿Dónde enviamos tu pedido?</span>
      </div>
      <div class="binga-shipping-selects">
        <select id="binga-region" class="binga-select">
          <option value="">Región</option>
        </select>
        <select id="binga-comuna" class="binga-select" disabled>
          <option value="">Comuna</option>
        </select>
      </div>
      <div id="binga-rates" class="binga-rates"></div>
    `;

    // Poblar regiones
    const regionSelect = document.getElementById('binga-region');
    Object.keys(this.regions).forEach(code => {
      const option = document.createElement('option');
      option.value = code;
      option.textContent = this.regions[code].name;
      regionSelect.appendChild(option);
    });
  },

  // Renderizar selector de documento
  renderDocumentSelector() {
    const container = document.getElementById('binga-document');
    if (!container) return;

    container.innerHTML = `
      <div class="binga-document-header">
        <span class="binga-icon">📄</span>
        <span class="binga-title">Documento tributario</span>
      </div>
      <div class="binga-document-options">
        <label class="binga-radio-label">
          <input type="radio" name="attributes[documento]" value="boleta" checked>
          <span class="binga-radio-text">Boleta</span>
        </label>
        <label class="binga-radio-label">
          <input type="radio" name="attributes[documento]" value="factura">
          <span class="binga-radio-text">Factura</span>
        </label>
      </div>
      <div id="binga-factura-fields" class="binga-factura-fields" style="display: none;">
        <input type="text" id="binga-rut" name="attributes[RUT]" class="binga-input" placeholder="RUT (ej: 12345678-9)">
        <div id="binga-rut-error" class="binga-error"></div>
        <input type="text" id="binga-razon" name="attributes[razon]" class="binga-input" placeholder="Razón Social">
        <select id="binga-giro" name="attributes[giro]" class="binga-select">
          <option value="">Selecciona tu giro</option>
        </select>
      </div>
    `;

    // Poblar giros (versión simplificada - los más comunes primero)
    this.populateGiros();
  },

  // Poblar selector de giros
  populateGiros() {
    const select = document.getElementById('binga-giro');
    if (!select) return;

    const girosComunes = [
      { code: "479100", name: "Venta al por menor por internet" },
      { code: "461001", name: "Corretaje al por mayor" },
      { code: "471100", name: "Supermercados e hipermercados" },
      { code: "472101", name: "Almacenes y minimarket" },
      { code: "561000", name: "Restaurantes y servicio de comidas" },
      { code: "620100", name: "Programación informática" },
      { code: "620200", name: "Consultoría informática" },
      { code: "692000", name: "Contabilidad y auditoría" },
      { code: "691001", name: "Servicios jurídicos" },
      { code: "862031", name: "Servicios médicos independientes" },
      { code: "862032", name: "Servicios odontológicos" },
      { code: "107100", name: "Panadería y pastelería" },
      { code: "105000", name: "Productos lácteos" },
      { code: "410010", name: "Construcción residencial" },
      { code: "421000", name: "Construcción carreteras" },
      { code: "492300", name: "Transporte de carga" },
      { code: "681011", name: "Arriendo de inmuebles" },
    ];

    girosComunes.forEach(giro => {
      const option = document.createElement('option');
      option.value = giro.name;
      option.textContent = `[${giro.code}] ${giro.name}`;
      select.appendChild(option);
    });

    // Agregar opción para ver todos
    const optionOtro = document.createElement('option');
    optionOtro.value = "_otro";
    optionOtro.textContent = "» Ver todos los giros...";
    select.appendChild(optionOtro);
  },

  // Vincular eventos
  bindEvents() {
    // Cambio de región
    const regionSelect = document.getElementById('binga-region');
    if (regionSelect) {
      regionSelect.addEventListener('change', (e) => this.onRegionChange(e.target.value));
    }

    // Cambio de comuna
    const comunaSelect = document.getElementById('binga-comuna');
    if (comunaSelect) {
      comunaSelect.addEventListener('change', (e) => this.onComunaChange(e.target.value));
    }

    // Cambio de tipo de documento
    const docRadios = document.querySelectorAll('input[name="attributes[documento]"]');
    docRadios.forEach(radio => {
      radio.addEventListener('change', (e) => this.onDocumentTypeChange(e.target.value));
    });

    // Validación de RUT
    const rutInput = document.getElementById('binga-rut');
    if (rutInput) {
      rutInput.addEventListener('input', (e) => this.onRutInput(e.target));
      rutInput.addEventListener('blur', () => this.updateCheckoutButton());
    }

    // Razón social
    const razonInput = document.getElementById('binga-razon');
    if (razonInput) {
      razonInput.addEventListener('input', () => this.updateCheckoutButton());
    }

    // Cambio de giro
    const giroSelect = document.getElementById('binga-giro');
    if (giroSelect) {
      giroSelect.addEventListener('change', (e) => {
        this.onGiroChange(e.target.value);
        this.updateCheckoutButton();
      });
    }
  },

  // Evento: cambio de región
  onRegionChange(regionCode) {
    this.state.region = regionCode;
    this.state.comuna = '';
    this.state.selectedRate = null;

    const comunaSelect = document.getElementById('binga-comuna');
    const ratesContainer = document.getElementById('binga-rates');

    if (!regionCode) {
      comunaSelect.innerHTML = '<option value="">Comuna</option>';
      comunaSelect.disabled = true;
      ratesContainer.innerHTML = '';
      this.updateCheckoutButton();
      return;
    }

    // Poblar comunas
    const comunas = this.regions[regionCode].comunas;
    comunaSelect.innerHTML = '<option value="">Comuna</option>';
    comunas.forEach(comuna => {
      const option = document.createElement('option');
      option.value = comuna;
      option.textContent = comuna;
      comunaSelect.appendChild(option);
    });
    comunaSelect.disabled = false;

    ratesContainer.innerHTML = '';
    this.updateCheckoutButton();
  },

  // Evento: cambio de comuna
  async onComunaChange(comuna) {
    this.state.comuna = comuna;
    this.state.selectedRate = null;

    if (!comuna) {
      document.getElementById('binga-rates').innerHTML = '';
      this.updateCheckoutButton();
      return;
    }

    // Actualizar URL del form para pre-llenar checkout
    this.updateFormAction();

    // Obtener tarifas
    await this.fetchRates();
  },

  // Actualizar action del form para pre-llenar checkout
  updateFormAction() {
    const form = document.querySelector('form.cart, form[action="/cart"]');
    if (!form) return;

    const params = new URLSearchParams();
    params.set('checkout[shipping_address][country]', 'CL');
    params.set('checkout[shipping_address][province]', this.state.region);
    params.set('checkout[shipping_address][city]', this.state.comuna);
    params.set('checkout[shipping_address][zip]', this.state.comuna);

    form.action = '/cart?' + params.toString();
    this.log('Form action actualizado:', form.action);
  },

  // Obtener tarifas de envío
  async fetchRates() {
    const container = document.getElementById('binga-rates');
    container.innerHTML = '<div class="binga-loading">Calculando envío...</div>';

    try {
      const url = `/cart/shipping_rates.json?shipping_address[country]=Chile&shipping_address[province]=${this.state.region}&shipping_address[city]=${encodeURIComponent(this.state.comuna)}&shipping_address[zip]=RATE`;
      
      const response = await fetch(url);
      const data = await response.json();

      if (data.shipping_rates && data.shipping_rates.length > 0) {
        this.renderRates(data.shipping_rates);
      } else {
        container.innerHTML = '<div class="binga-no-rates">No hay envío disponible para esta comuna</div>';
      }
    } catch (error) {
      this.log('Error obteniendo tarifas:', error);
      container.innerHTML = '<div class="binga-error">Error al calcular envío. Intenta de nuevo.</div>';
    }

    this.updateCheckoutButton();
  },

  // Renderizar tarifas
  renderRates(rates) {
    const container = document.getElementById('binga-rates');
    
    let html = '<div class="binga-rates-list">';
    rates.forEach((rate, index) => {
      const price = this.formatPrice(rate.price);
      const isFirst = index === 0;
      
      html += `
        <label class="binga-rate-option ${isFirst ? 'selected' : ''}">
          <input type="radio" name="binga_rate" value="${rate.name}" ${isFirst ? 'checked' : ''} data-price="${rate.price}">
          <span class="binga-rate-info">
            <span class="binga-rate-name">${rate.name}</span>
          </span>
          <span class="binga-rate-price">${price}</span>
        </label>
      `;
    });
    html += '</div>';

    container.innerHTML = html;

    // Seleccionar primera tarifa por defecto
    if (rates.length > 0) {
      this.state.selectedRate = rates[0];
      this.updateShippingDisplay(rates[0].price);
    }

    // Evento para cambio de tarifa
    container.querySelectorAll('input[name="binga_rate"]').forEach(radio => {
      radio.addEventListener('change', (e) => {
        const price = e.target.dataset.price;
        const name = e.target.value;
        this.state.selectedRate = { name, price };
        this.updateShippingDisplay(price);
        
        // Actualizar clase selected
        container.querySelectorAll('.binga-rate-option').forEach(opt => opt.classList.remove('selected'));
        e.target.closest('.binga-rate-option').classList.add('selected');
      });
    });
  },

  // Actualizar display de envío en el resumen
  updateShippingDisplay(price) {
    const shippingDisplay = document.getElementById('binga-shipping-cost');
    if (shippingDisplay) {
      shippingDisplay.textContent = this.formatPrice(price);
    }

    // Actualizar total si existe
    const subtotalEl = document.querySelector('.cart__subtotal, [data-cart-subtotal]');
    const totalEl = document.getElementById('binga-total');
    
    if (subtotalEl && totalEl) {
      const subtotalText = subtotalEl.textContent.replace(/[^\d]/g, '');
      const subtotal = parseInt(subtotalText) || 0;
      const shipping = parseInt(price) || 0;
      totalEl.textContent = this.formatPrice(subtotal + shipping);
    }
  },

  // Evento: cambio tipo de documento
  onDocumentTypeChange(type) {
    this.state.documentType = type;
    const facturaFields = document.getElementById('binga-factura-fields');
    
    if (facturaFields) {
      facturaFields.style.display = type === 'factura' ? 'block' : 'none';
    }

    this.updateCheckoutButton();
  },

  // Evento: input de RUT
  onRutInput(input) {
    let value = input.value.replace(/[^\dkK]/g, '');
    
    if (value.length > 1) {
      const cuerpo = value.slice(0, -1);
      const dv = value.slice(-1).toUpperCase();
      input.value = cuerpo + '-' + dv;
    }

    this.validateRut(input);
  },

  // Validar RUT chileno
  validateRut(input) {
    const errorEl = document.getElementById('binga-rut-error');
    const value = input.value.replace(/[.-]/g, '');
    
    if (value.length < 8) {
      input.classList.remove('valid', 'invalid');
      if (errorEl) errorEl.textContent = '';
      this.updateCheckoutButton();
      return false;
    }

    const cuerpo = value.slice(0, -1);
    const dvIngresado = value.slice(-1).toUpperCase();

    // Calcular dígito verificador
    let suma = 0;
    let multiplo = 2;

    for (let i = cuerpo.length - 1; i >= 0; i--) {
      suma += parseInt(cuerpo[i]) * multiplo;
      multiplo = multiplo === 7 ? 2 : multiplo + 1;
    }

    const dvEsperado = 11 - (suma % 11);
    let dvCalculado;
    
    if (dvEsperado === 11) dvCalculado = '0';
    else if (dvEsperado === 10) dvCalculado = 'K';
    else dvCalculado = dvEsperado.toString();

    const esValido = dvIngresado === dvCalculado;

    input.classList.toggle('valid', esValido);
    input.classList.toggle('invalid', !esValido);
    if (errorEl) errorEl.textContent = esValido ? '' : 'RUT inválido';

    this.updateCheckoutButton();
    return esValido;
  },

  // Evento: cambio de giro
  onGiroChange(value) {
    if (value === '_otro') {
      // Mostrar modal con todos los giros o abrir en nueva ventana
      window.open('https://www.sii.cl/ayudas/ayudas_por_servicios/1956-702.html', '_blank');
      document.getElementById('binga-giro').value = '';
    }
  },

  // Actualizar botón de checkout
  updateCheckoutButton() {
    const checkoutBtn = document.getElementById('binga-checkout-btn');
    const originalBtn = document.querySelector('input[name="checkout"], button[name="checkout"]');
    
    if (!checkoutBtn) return;

    const comunaSelected = this.state.comuna !== '';
    const rateSelected = this.state.selectedRate !== null;
    
    let facturaValid = true;
    if (this.state.documentType === 'factura') {
      const rutInput = document.getElementById('binga-rut');
      const razonInput = document.getElementById('binga-razon');
      const giroInput = document.getElementById('binga-giro');
      
      const rutValue = rutInput?.value?.trim() || '';
      const razonValue = razonInput?.value?.trim() || '';
      const giroValue = giroInput?.value || '';
      
      // RUT válido si tiene al menos 9 caracteres (12345678-9) y no tiene clase invalid
      const rutValid = rutValue.length >= 9 && !rutInput?.classList.contains('invalid');
      
      facturaValid = rutValid && razonValue !== '' && giroValue !== '' && giroValue !== '_otro';
      
      this.log('Factura validation:', { rutValue, razonValue, giroValue, rutValid, facturaValid });
    }

    const isReady = comunaSelected && rateSelected && facturaValid;
    this.state.isReady = isReady;

    checkoutBtn.disabled = !isReady;
    checkoutBtn.classList.toggle('ready', isReady);

    if (isReady) {
      checkoutBtn.textContent = 'Ir a pagar';
      checkoutBtn.onclick = () => {
        // Validar términos y condiciones
        const termsCheckbox = document.getElementById('binga-terms-check');
        if (termsCheckbox && !termsCheckbox.checked) {
          alert('Debes aceptar los términos y condiciones para continuar.');
          return;
        }
        if (originalBtn) originalBtn.click();
      };
    } else {
      let mensaje = 'Selecciona tu comuna';
      if (comunaSelected && !rateSelected) mensaje = 'Calculando envío...';
      if (comunaSelected && rateSelected && !facturaValid) mensaje = 'Completa datos de factura';
      checkoutBtn.textContent = mensaje;
      checkoutBtn.onclick = null;
    }

    // Ocultar botón original
    if (originalBtn) {
      originalBtn.style.display = 'none';
    }
  },

  // Formatear precio
  formatPrice(price) {
    const num = parseInt(price) || 0;
    return new Intl.NumberFormat('es-CL', { 
      style: 'currency', 
      currency: 'CLP',
      minimumFractionDigits: 0 
    }).format(num);
  },

  // Log de debug
  log(...args) {
    if (this.config.debug) {
      console.log('[BingaCart]', ...args);
    }
  }
};

// Auto-inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  // Solo inicializar en página de carrito
  if (window.location.pathname.includes('/cart')) {
    BingaCart.init();
  }
});